import { h } from '@stencil/core';
import tripPlanner from 'store/tripPlanner';
import { getImageUrl } from 'utils/utils';
import { TripItemPoiDetail } from 'client/trip-planner/types';
import { initAllCarousels } from 'utils/carousel';
import { i18n } from 'i18n';

export default function TripItemPoiDetail({ show, poi }: { show: boolean; poi: string }) {
  requestAnimationFrame(() => {
    if (show) {
      initAllCarousels(document.getElementById('item-photo-gallery'), 'CARDS', { pagination: false });
      initAllCarousels(document.getElementById('tip-carousel'), 'PICTURES', { navigation: false, slidesPerView: 1 });
    }
  });

  const detail: TripItemPoiDetail = tripPlanner.item!.detail as TripItemPoiDetail;
  const hasDetail = typeof detail !== 'undefined';

  const reviews = hasDetail && detail.userReviews ? detail.userReviews.length : 0 || 0;

  return (
    <div class="item-detail">
      {tripPlanner.item!.position && (
        <div class="item-map">
          <chat-map-view data-model={poi} autoHeight={true} />
        </div>
      )}
      <div class="item-content">
        <div class="item-body">
          <h4 class="eva-3-h4 item-text">{tripPlanner.item!.title}</h4>
          {reviews > 0 && <h6 class="eva-3-h6 item-reviews">{i18n.t.tripPlanner.reviews(reviews)}</h6>}
        </div>
        {hasDetail && detail.gallery && (
          <div id="item-photo-gallery" class="photo-gallery">
            <div class="swiper-container">
              <div class="swiper">
                <div class="swiper-wrapper">
                  {detail.gallery.map(image => (
                    <img class="swiper-slide item-photo" src={getImageUrl(image, 300, 200)} alt="Thumb image" />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {hasDetail && detail.tips && (
          <div class="tips">
            <h6 class="eva-3-h6 tips-title">{i18n.t.tripPlanner.tips}</h6>
            <div id="tip-carousel" class="tip-carrousel">
              <div class="swiper-container">
                <div class="swiper">
                  <div class="swiper-wrapper">
                    {detail.tips.map(tip => (
                      <p class="swiper-slide eva-3-body-2 tip" innerHTML={tip.tip} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
